module.exports = __webpack_public_path__ + "static/header-logo-25d46c8d3c2c61815c088fbc6ddcfc4a.png";